module.exports = __webpack_public_path__ + "static/media/22ESCWA18.ee0ced2d.jpg";